import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";

function RadialBar() {
  const { options, series } = useMemo(
    () => ({
      options: {
        colors: [colors.ReactifyChartColor1],
        plotOptions: {
          radialBar: {
            hollow: {
              size: "70%"
            }
          }
        },
        labels: ["Sales Goal"]
      },
      series: [70]
    }),
    []
  );

  return (
    <Chart
      options={options}
      series={series}
      type="radialBar"
      width="100%"
      height="280px"
    />
  );
}

export default RadialBar;
